import React from 'react';
import { Apps } from '@axtria/hqi-configurator';
import '@axtria/hqi-configurator/lib/hqi-configurator.css';
import { useSelector } from 'react-redux';
const baseURL = process.env.REACT_APP_HQI_BASE_URL
const middlewareURL = process.env.REACT_APP_HQI_MIDDLEWARE_URL
const UMUrl = process.env.REACT_API_URL

const AiAgents = () => {
  const { userInfo } = useSelector((state: any) => ({
      userInfo: state.loginResource,
    }));
  return <>
    <Apps
      DOMAIN={baseURL}
      DOMAIN_UM={UMUrl}
      DOMAIN_MIDDLEWARE={middlewareURL}
      PROJECT_ID={userInfo.preferredProject}
    />
  </>;
};

export default AiAgents;